








import { Vue, Component } from 'vue-property-decorator'
import * as drills from '@/drills'

@Component
export default class DrillList extends Vue {

	list = Object.keys(drills)

}
